import React from 'react';
import {
  Avatar,
  Card,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { Fragment } from 'react';
import { FaCarSide, FaHelicopter, FaMotorcycle, FaTractor, FaTrailer } from 'react-icons/fa';
import { GiBus, GiTruck } from 'react-icons/gi';
import { RiTruckFill } from 'react-icons/ri';
import { ConsultValuesProps } from '../../../pages/User/types';
import { v4 as uuidv4 } from 'uuid';

type ListItemValuesProps = {
  index: number;
  itemType: string;
  indexSelected: number;
  plate?: string;
  chassi?: string;
  model?: string;
  email: string;
  created_at: string;
  hash: string;
  items: ConsultValuesProps[];
  setIndexSelected: (value: React.SetStateAction<number>) => void;
  pricing: boolean;
};

export default function ListItemValues({
  index,
  itemType,
  indexSelected,
  plate,
  chassi,
  model,
  email,
  created_at,
  items,
  setIndexSelected,
  pricing,
  hash
}: ListItemValuesProps): JSX.Element {

  return (
    <Card key={`fiv-list-item-${index}`} style={{ marginTop: 20 }}>
      <ListItemButton
        onClick={() => {
          setIndexSelected(index);
        }}
      >
        <ListItemIcon>
          <Avatar>
            {itemType === '1' ? (
              <FaTractor />
            ) : itemType === '2' ? (
              <FaHelicopter aria-label="helicopter-icon" />
            ) : itemType === '3' ? (
              <FaTrailer />
            ) : itemType === '4' ? (
              <RiTruckFill />
            ) : itemType === '5' ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <GiTruck />
                <GiBus />
              </div>
            ) : itemType === '6' ? (
              <img
                width="20"
                height="20"
                src="https://img.icons8.com/material-rounded/96/harvester.png"
                alt="harvester"
              />
            ) : (
              <div style={{ display: 'flex', flexDirection: "column", }}>
                <FaMotorcycle aria-label="moto-icon" /><FaCarSide aria-label="carro-icon" />
              </div>
            )}
          </Avatar>
        </ListItemIcon>
        <ListItemText
          sx={{ userSelect: 'text', cursor: 'text' }}
          key={`fiv-list-item-${index}`}
          primary={
            <Fragment>
              <Typography variant="body1" color="text.primary">
                {pricing ? (
                  <>
                    <strong>Placa: </strong>
                    {plate ? plate : '-'}
                    <br />
                    <strong>Chassi: </strong>
                    {chassi}
                  </>
                ) : (
                  <>
                    <strong>Modelo: </strong>
                    {model}
                  </>
                )}
              </Typography>
            </Fragment>
          }
          secondary={
            <Fragment>
              <Typography
                sx={{ display: 'inline' }}
                component="span"
                variant="body1"
                color="text.primary"
              >
                {`Consulta realizada por ${email} no dia ${created_at}`}
              </Typography>
            </Fragment>
          }
        />
      </ListItemButton>
      <Collapse
        in={index === indexSelected}
        timeout="auto"
        unmountOnExit
        key={index}
      >
        <List component="div" key={`list-${index}`} disablePadding>
          {items.map((item) => (
            <ListItem sx={{ pl: 4 }} key={uuidv4()}>
              <ListItemText
                primary={
                  <Fragment>
                    <Typography variant="body1" color="text.primary">
                      <strong>Cod: </strong>
                      {item.somos_code || item.codigo_fipe || item.aggregates_1?.codigo_fipe || item?.aggregates_2?.DsCodigo}
                    </Typography>
                    <Typography sx={{ overflowWrap: 'anywhere' }}
                      variant="body1" color="text.primary">
                      <strong>Hash: </strong>
                      {hash}
                    </Typography>
                    {item.month_reference && item.year_reference && (
                      <Typography sx={{ overflowWrap: 'anywhere' }}
                        variant="body1" color="text.primary">
                        <strong>Mês/Ano de referência: </strong>
                        {item.month_reference}/{item.year_reference}
                      </Typography>

                    )}
                    <Typography variant="body1" color="text.primary">
                      <strong>Marca: </strong>
                      {item.mounter || item.DsMarca}
                    </Typography>
                    {pricing ? (
                      <Typography variant="body1" color="text.primary">
                        <strong>Modelo: </strong>
                        {item.model || item.DsModelo}
                      </Typography>
                    ) : (
                      <></>
                    )}
                    {item.NuValor ? (
                      <></>
                    ) : (
                      itemType !== '7' ? 
                      <Typography variant="body1" color="text.primary">
                        <strong>Ano: </strong>
                        {item.year}
                      </Typography> : 
                      <Typography variant="body1" color="text.primary">
                        <strong>Em produção?: </strong>
                        {item.em_producao}
                      </Typography>
                    )}
                    {(item.NuValor !== undefined ||
                      item.value !== undefined) && (
                        <Typography variant="body1" color="text.primary">
                          <strong>Valor: </strong>
                          {item.type !== '5' ? 'R$ ' : ''}
                          {(item.NuValor ?? item.value ?? item.initial_value).toLocaleString()}
                        </Typography>
                      )}
                    {item?.substitutes?.length > 0 &&
                      <List >
                        {
                          item?.substitutes?.map((item: any, index: number) => (
                            <ListItemText style={{ border: 'solid 1px #d5ccdb', borderRadius: '1rem', padding: '1rem' }} key={index}>
                              <Typography style={{ margin: '.5rem 0rem' }} variant="body1" color="text.secondy">
                                <strong>SUBSTITUIÇÃO {item.index}</strong>
                              </Typography>
                              <Typography variant="body1" color="text.primary">
                                <strong>Fabricante: </strong>
                                {item.mounter || item.DsModelo}
                              </Typography>
                              <Typography variant="body1" color="text.primary">
                                <strong>Modelo: </strong>
                                {item.model}
                              </Typography>
                              <Typography variant="body1" color="text.primary">
                                <strong>Valor: </strong>
                                R$ {Number(item.current_value).toLocaleString('pt-BR', {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}*
                              </Typography>
                              <Typography variant="body1" color="text.primary">
                                <strong>Variação em percentual: </strong>
                                <span style={{ color: item.variation_percent < 0 ? 'red' : 'green' }}>
                                  {item.variation_percent}%
                                </span>
                              </Typography>

                            </ListItemText>
                          ))}

                      </List>
                    }
                  </Fragment>
                }
              />
              <Divider />
            </ListItem>
          ))}
        </List>
      </Collapse>
    </Card>
  );
}
